import PaginaNaoEncontrada from '@/views/pages/commons/pagina-nao-encontrada/PaginaNaoEncontrada'
import ValidarDocumento from '@/views/pages/commons/validar-documento/ValidarDocumento'
import ConsultaDeLicitacoes from '@/views/pages/commons/licitacao/consulta-licitacoes/ConsultaDeLicitacoes'
import LicitacaoVisualizacao from '@/views/pages/commons/licitacao/detalhe/LicitacaoVisualizacao'
import LicitacaoVisualizacaoAcompanhamento from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/LicitacaoVisualizacaoAcompanhamento'
import LicitacaoVisualizacaoDadosGerais from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/LicitacaoVisualizacaoDadosGerais'
import LicitacaoVisualizacaoDadosEdital from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/LicitacaoVisualizacaoDadosEdital'
import LicitacaoVisualizacaoEsclarecimentoImpugnacao from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/LicitacaoVisualizacaoEsclarecimentoImpugnacao'
import LicitacaoVisualizacaoSimularProposta from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/LicitacaoVisualizacaoSimularProposta'
import ValidarCodigoEmail from '@/views/pages/commons/validar-codigo-email/ValidarCodigoEmail'
import LicitacaoVisualizacaoDetalhesLote from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/LicitacaoVisualizacaoDetalhesLote.vue'
import CredenciamentoVisualizacao from '@/views/pages/commons/credenciamento/detalhe/CredenciamentoVisualizacao.vue'
import CredenciamentoVisualizacaoDadosGerais from '@/views/pages/commons/credenciamento/detalhe/etapas-visualizacao/CredenciamentoVisualizacaoDadosGerais.vue'
import CredenciamentoVisualizacaoDadosEdital from '@/views/pages/commons/credenciamento/detalhe/etapas-visualizacao/CredenciamentoVisualizacaoDadosEdital.vue'
import CredenciamentoVisualizacaoEsclarecimentoImpugnacao from '@/views/pages/commons/credenciamento/detalhe/etapas-visualizacao/CredenciamentoVisualizacaoEsclarecimentoImpugnacao.vue'
import CredenciamentoVisualizacaoResultado from '@/views/pages/commons/credenciamento/detalhe/etapas-visualizacao/CredenciamentoVisualizacaoResultado.vue'
import CredenciamentoVisualizacaoLotesItens from '@/views/pages/commons/credenciamento/detalhe/etapas-visualizacao/CredenciamentoVisualizacaoLotesItens.vue'

export default [
    {
        path: '/',
        name: 'home',
        redirect: '/consulta-licitacoes',
    },
    {
        path: '/consulta-licitacoes',
        name: 'consultaDeLicitacoes',
        component: ConsultaDeLicitacoes,
        meta: {
            page: {
                title: 'Editais',
            },
        }
    },
    {
        path: '/licitacao-visualizacao/:id',
        name: 'licitacaoVisualizacao',
        component: LicitacaoVisualizacao,
        redirect: '/licitacao-visualizacao/:id/dados-gerais',
        children:[
            {
                path: 'dados-gerais',
                name: 'licitacaoVisualizacaoDadosGerais',
                component: LicitacaoVisualizacaoDadosGerais,
                meta: {
                    page: {
                        title: 'Licitação',
                        subtitle: 'Esclarecimento e Impugnação'
                    }
                }
            },
            {
                path: 'dados-edital',
                name: 'licitacaoVisualizacaoEdital',
                component: LicitacaoVisualizacaoDadosEdital,
                meta: {
                    page: {
                        title: 'Licitação',
                        subtitle: 'Esclarecimento e Impugnação'
                    }
                }
            },
            {
                path: 'esclarecimento-impugnacao',
                name: 'licitacaoVisualizacaoEsclarecimentoImpugnacao',
                component: LicitacaoVisualizacaoEsclarecimentoImpugnacao,
                meta: {
                    page: {
                        title: 'Licitação',
                        subtitle: 'Esclarecimento e Impugnação'
                    }
                }
            },
            {
                path: 'simular-proposta',
                name: 'licitacaoVisualizacaoSimularProposta',
                component: LicitacaoVisualizacaoSimularProposta,
                meta: {
                    page: {
                        title: 'Licitação',
                        subtitle: 'Simular Proposta'
                    }
                }
            },
            {
                path: 'acompanhamento',
                name: 'licitacaoVisualizacaoAcompanhamento',
                component: LicitacaoVisualizacaoAcompanhamento,
                meta: {
                    page: {
                        title: 'Licitação',
                        subtitle: 'Acompanhamento'
                    }
                }
            },
        ]
    },
    {
        path: '/licitacao-visualizacao/:id/acompanhamento/detalhes',
        name: 'licitacaoVisualizacaoDetalhesLote',
        component: LicitacaoVisualizacaoDetalhesLote,
        meta: {
            page: {
                title: 'Licitação',
                subtitle: 'Detalhes Acompanhamento'
            }
        }
    },
    {
        path: '/credenciamento-visualizacao/:id',
        name: 'credenciamentoVisualizacao',
        component: CredenciamentoVisualizacao,
        redirect: '/credenciamento-visualizacao/:id/dados-gerais',
        children:[
            {
                path: 'dados-gerais',
                name: 'credenciamentoVisualizacaoDadosGerais',
                component: CredenciamentoVisualizacaoDadosGerais,
                meta: {
                    page: {
                        title: 'Credenciamento',
                        subtitle: 'Credenciamento'
                    }
                }
            },
            {
                path: 'dados-edital',
                name: 'credenciamentoVisualizacaoEdital',
                component: CredenciamentoVisualizacaoDadosEdital,
                meta: {
                    page: {
                        title: 'Credenciamento',
                        subtitle: 'Dados do Edital'
                    }
                }
            },
            {
                path: 'lotesItens',
                name: 'CredenciamentoVisualizacaoLotesItens',
                component: CredenciamentoVisualizacaoLotesItens,
                meta: {
                    page: {
                        title: 'Credenciamento',
                        subtitle: 'Itens'
                    }
                }
            },
            {
                path: 'esclarecimento-impugnacao',
                name: 'credenciamentoVisualizacaoEsclarecimentoImpugnacao',
                component: CredenciamentoVisualizacaoEsclarecimentoImpugnacao,
                meta: {
                    page: {
                        title: 'Credenciamento',
                        subtitle: 'Esclarecimento e Impugnação'
                    }
                }
            },
            {
                path: 'resultado',
                name: 'credenciamentoVisualizacaoResultado',
                component: CredenciamentoVisualizacaoResultado,
                meta: {
                    page: {
                        title: 'Credenciamento',
                        subtitle: 'Resultado'
                    }
                }
            },
        ]
    },
    {
        path: '/validar-documento',
        name: 'ValidarDocumento',
        component: ValidarDocumento,
        meta: {
            page: {
                title: 'Documento',
                subtitle: 'Validar Documento'
            },
        }
    },
    {
        path: '/validar-documento/:codigo',
        name: 'ValidarDocumentoDireto',
        component: ValidarDocumento,
        meta: {
            page: {
                title: 'Documento',
                subtitle: 'Validar Documento'
            },
        }
    },
    {
        path: '*',
        name: 'PaginaNaoEncontrada',
        component: PaginaNaoEncontrada,
        meta: {
            page: {
                title: 'Ooops',
                subtitle: 'Página não encontrada'
            },
            scrollToTop: false
        }
    },
    {
        path: '/esclarecimento-impugnacao/confirmar/:codigo',
        name: 'ValidarCodigoEmailDireto',
        component: ValidarCodigoEmail
    },
]
